import { axios } from "../../lib/axios";

export const DeleteTopicCategory = (topicId: string) => {
    return axios.delete(`/question-bank-category/${topicId}`)
        .then(response => response.data);
};

